import type { PrepackageSearchState } from '../types';

export const ppDefaultState: PrepackageSearchState = {
    searchType: 'fixed',
    originAirport: '',
    destination: '',
    destinationId: undefined,
    departureDate: null,
    returnDate: null,
    flexibleDeparture: 3,
    duration: {
        from: 5,
        to: 15,
    },
    facetData: {},
    travelMonths: [],
    numberOfAdults: 2,
    agesOfChildren: [],
};
